import React, {Component} from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Clearfix } from 'react-bootstrap';
import Alert from 'sweetalert-react';

import Utils from "../../lib/utils";
import ProfileDetailForm from "./ProfileDetailForm";
import PersonalDetailForm from "./PersonalDetailForm";

import { Container, Header, Button, Status } from "./Styles/Platform.style";

import {
  getProfiles as getProfilesAction,
  removeProfile as removeProfileAction,
  createProfile as createProfileAction,
  updateProfile as updateProfileAction,
} from "../../redux/middleware/profile";
import { removeEducation as removeEducationAction } from "../../redux/middleware/education";
import { removeWorkExperience as removeWorkExperienceAction } from "../../redux/middleware/workExperience";
import { removeSkill as removeSkillAction } from "../../redux/middleware/skill";
import {
  getCountries,
  getRegions,
} from "../../redux/middleware/internationalize.ts";
import {
  getProfiles,
  getProfilesError,
  getProfilesFilters,
  getProfilesTotal,
  getNewProfile,
  getProfilesUpdatePending,
} from "../../redux/reducers/profile";
import { getWorkExperiencePending } from "../../redux/reducers/workExperience";
import { getSkillPending } from "../../redux/reducers/skill";
import { getEducationPending } from "../../redux/reducers/education";
import { getResumePending, getResumeError } from "../../redux/reducers/resume";

class ProfileForm extends Component {
  constructor(props) {
    super(props);

    // Initialize state
    this.state = {
      showAlert: false,
      alertMessage: "",
      alertType: "info",
      fname: props.user.fname || "",
      lname: props.user.lname || "",
      phone: props.user.phone_primary || "",
      email: props.user.email || "",
      city: props.user.city || "",
      state: props.user.state || "",
      zip: props.user.zip || "",
      country: props.user.country || "",
      profile: {},
      countries: [],
      regions: [],
    };
  }

  componentWillMount() {
    const { getProfiles, user, getCountries: getCountriesAction } = this.props;
    getProfiles(user.id);
    this.getResume();
    getCountriesAction();
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.profile) {
      this.setState({ profile: nextProps.profile });
    }

    if (nextProps.profile && !this.props.profile) {
      this.props.getRegionsAction(
        Utils.getCountryCode(nextProps.countries, nextProps.job.country)
      );
    }

    if (nextProps.newProfile) {
      this.setState((prevState) => ({
        ...prevState,
        profile: {
          ...prevState.profile,
          ...nextProps.newProfile,
        },
      }));
    }
    if (nextProps.profile || nextProps.countries) {
      this.setState((prevState) => ({
        ...prevState,
        countries: nextProps.countries,
        profile: {
          ...nextProps.profile,
          clearance: nextProps.profile?.security_clearance,
          citizen: nextProps.profile?.us_citizen,
          skillSets: nextProps.profile?.skill_sets,
          workExperiences: nextProps.profile?.work_experiences,
        },
      }));
    }
    if (nextProps.regions) {
      this.setState((prevState) => ({
        ...prevState,
        regions: nextProps.regions,
      }));
    }

    if (nextProps.countries.length && !this.props.countries.length) {
      this.props.getRegions(
        Utils.getCountryCode(nextProps.countries, nextProps.user.country)
      );
    }

    this.notifications(nextProps);
    this.getResume();
  }

  notifications = (nextProps) => {
    if (
      this.props.deleteWorkExperiencePending &&
      !nextProps.deleteWorkExperiencePending
    ) {
      nextProps.notify("error", "Work experience has been deleted");
    }
    if (this.props.pendingUpdate && !nextProps.pendingUpdate) {
      nextProps.notify("info", "Your profile has been updated");
    }
    if (this.props.deleteSkillPending && !nextProps.deleteSkillPending) {
      nextProps.notify("error", "Your skill has been deleted");
    }
    if (
      this.props.resumePending &&
      !nextProps.resumePending &&
      nextProps.resumeError
    ) {
      nextProps.notify("error", "Your resume could not be uploaded, try again");
    }
    if (
      this.props.deleteEducationPending &&
      !nextProps.deleteEducationPending
    ) {
      nextProps.notify("error", "Your education has been deleted");
    }
  };

  mapUserRequestParams = () => {
    return {
      id: this.props.user.id,
      fname: this.state.fname,
      lname: this.state.lname,
      email: this.state.email,
      phone_primary: this.state.phone,
      zip: this.state.zip,
      city: this.state.city,
      state: this.state.state,
      country: this.state.country,
    };
  };

  mapProfileRequestParams = () => {
    let profile = {
      salary: this.state.profile.salary,
      hourly_rate: this.state.profile.hourly_rate,
      user_id: this.props.user.id,
      title: this.state.profile.title,
      primary: this.state.profile.primary,
      searchable: this.state.profile.searchable,
      security_clearance: this.state.profile.security_clearance,
      us_citizen: this.state.profile.us_citizen,
      relocate: this.state.profile.relocate,
      veteran: this.state.profile.veteran,
      position_type: this.state.profile.position_type,
    };

    // if props.profile empty consider new and return profile
    if (!this.props.profile) return profile;

    // set id so that profile is updated
    profile["id"] = this.props.profile.id;
    return Utils.convertToSnakeCase(profile);
  };

  /** Work experiences **/

  addWorkExperience = (exp) => {
    const profile = this.mapProfileRequestParams();
    profile["work_experiences_attributes"] = exp;
    profile.primary = false;
    if (this.props.profile === undefined) {
      this.props.createProfile(this.props.user, profile, null, "edit");
    } else {
      profile["id"] = this.props.profile.id;
      this.props.updateProfile(this.props.user, profile);
    }
  };

  deleteWorkExperience = (id) => this.props.removeWorkExperience(id);

  addEducation = (education) => {
    const profile = this.mapProfileRequestParams();
    const user = this.mapUserRequestParams();
    profile["educations_attributes"] = education;
    if (this.props.profile === undefined) {
      this.props.createProfile(user, profile, null, "edit");
    } else {
      profile["id"] = profile.id;
      this.props.updateProfile(this.props.user, profile);
    }
  };

  deleteEducation = (id) => this.props.removeEducation(id);

  /** Skill sets **/

  addSkillSet = (skillSet) => {
    const user = this.mapUserRequestParams();
    const profile = this.mapProfileRequestParams();
    profile["skill_sets_attributes"] = skillSet;
    profile.primary = false;
    if (this.props.profile === undefined) {
      this.props.createProfile(user, profile, null, "edit");
    } else {
      profile["id"] = this.props.profile.id;
      this.props.updateProfile(user, profile);
    }
  };

  deleteSkillSet = (id) => this.props.removeSkill(id);

  handleAction = () => {
    const {
      profile: { resume },
    } = this.state;
    const {
      action,
      updateProfile,
      createProfile,
      history,
      profiles,
      profile: currentProfile,
    } = this.props;
    const data = new FormData();
    const profile = this.mapProfileRequestParams();
    const user = this.mapUserRequestParams();
    let resumeData;
    if (resume && resume[0].size) {
      resume && resume[0].size && data.append("resume", resume[0]);
      resumeData = resume && resume[0].size && data;
    }
    if (action === "update") {
      updateProfile(user, profile, resumeData, resumeData && resume[0].name);
    } else {
      createProfile(user, profile, resumeData, resumeData && resume[0].name);
    }
    const updatedProfiles = [
      ...profiles.filter((p) => p.id !== currentProfile.id),
      { ...currentProfile, ...profile },
    ];
    history.push({
      pathname: "/dashboard/profiles",
      profiles: updatedProfiles,
    });
  };

  getResume = () => {
    const { profiles, profile_id, resumes } = this.props;
    const profile =
      profiles && profiles.find((profile) => profile.id === Number(profile_id));

    const resumeId = profile && profile.resume_id;
    const resume = resumes && resumes.find((resume) => resume.id === resumeId);

    resumeId &&
      this.setState((state) => {
        return {
          ...state,
          profile: {
            ...state.profile,
            resume: [{ name: resume && resume.name }],
          },
        };
      });
  };

  handleChange = (event) => {
    const { getRegions: getRegionsAction, countries } = this.props;
    const { name, type } = event.target;
    let value;

    const profileFields = [
      "salary",
      "hourly_rate",
      "title",
      "primary",
      "searchable",
      "security_clearance",
      "us_citizen",
      "relocate",
      "veteran",
      "position_type",
      "resume",
    ];

    if (type === "checkbox") value = event.target.checked;
    else if (type === "file")
      value = event.target.files[0] && event.target.files;
    else value = event.target.value;
    if (name === "country")
      getRegionsAction(Utils.getCountryCode(countries, value));

    // if name in array save to profile
    if (profileFields.includes(name)) {
      let changeState = Object.assign({}, this.state.profile);
      changeState[name] = value;
      this.setState({ profile: changeState });
    } else {
      this.setState({ [name]: value });
    }
  };

  delete = (user, profile) => {
    this.props.removeProfile(user, profile);
    this.props.history.push(`/dashboard/profiles`);
  };

  render() {
    const { profile, countries, regions, country } = this.state;
    const user = this.mapUserRequestParams();

    if (!profile) return <div>Loading...</div>;

    return (
      <Container enctype="multipart/form-data" className="tab_padd new_job_bg">
        <Header>
          <Status className="relative_top">
            {profile.searchable
              ? "Searchable (Editing):"
              : "Not Searchable (Editing):"}
          </Status>
          <Button
            type="button"
            className="btn btn-primary hidden-xs"
            disabled={!profile.id}
            onClick={() => this.delete(user, profile)}
          >
            Delete Profile
          </Button>
          <Button
            type="button"
            className="btn btn-primary"
            onClick={this.handleAction}
          >
            Done
          </Button>
        </Header>
        <Clearfix />
        <PersonalDetailForm
          profile={profile}
          countries={countries}
          regions={regions}
          country={country}
          user={user}
          handleChange={this.handleChange}
        />
        <hr />
        <ProfileDetailForm
          profile={profile}
          deleteProfile={this.deleteProfile}
          addSkillSet={this.addSkillSet}
          deleteSkillSet={this.deleteSkillSet}
          addEducation={this.addEducation}
          deleteEducation={this.deleteEducation}
          addWorkExperience={this.addWorkExperience}
          deleteWorkExperience={this.deleteWorkExperience}
          handleChange={this.handleChange}
        />
        <Alert
          show={this.state.showAlert}
          title="Resume"
          text={this.state.alertMessage}
          type={this.state.alertType}
          onConfirm={() => this.setState({ showAlert: false })}
        />
      </Container>
    );
  }
}

const mapStateToProps = (state) => ({
  error: getProfilesError(state),
  profiles: getProfiles(state),
  filters: getProfilesFilters(state),
  totalProfiles: getProfilesTotal(state),
  pendingUpdate: getProfilesUpdatePending(state),
  deleteSkillPending: getSkillPending(state),
  deleteWorkExperiencePending: getWorkExperiencePending(state),
  deleteEducationPending: getEducationPending(state),
  resumePending: getResumePending(state),
  resumeError: getResumeError(state),
  newProfile: getNewProfile(state),
  countries: state.countries?.countries,
  regions: state.regions?.regions,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getProfiles: getProfilesAction,
      removeProfile: removeProfileAction,
      createProfile: createProfileAction,
      updateProfile: updateProfileAction,
      removeEducation: removeEducationAction,
      removeWorkExperience: removeWorkExperienceAction,
      removeSkill: removeSkillAction,
      getCountries,
      getRegions,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(ProfileForm);
